<template>
  <a-modal
    title="添加学员"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="{'padding':'10px 25px'}"
  >
    <div class="game-setting-page">
      <a-form :form="form">
        <a-row>
          <a-col :span="7">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 22 }"
              label=""
            >
              <a-input placeholder="学员姓名" v-model="queryParam.realname"/>
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 22 }"
              label=""
            >
              <a-input placeholder="学员手机号" v-model="queryParam.phone"/>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="7"> -->
            <!-- <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 22 }"
              label=""
            > 
            <j-dict-select-tag  :triggerChange="true" placeholder="课程来源"
                dictCode="sex"/>
            </a-form-item>
          </a-col> -->
          <!-- <a-col :span="7">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 22 }"
              label="   "
            > 

            <a-select
                placeholder="所在班级" >
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;margin-top:4px;">筛选</a-button>
        </a-row>
      </a-form>
      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        @change="handleTableChange"
      >
        
      </a-table>
    </div>
  </a-modal>
</template>

<script>
// import moment from 'moment'
// import pick from 'lodash.pick'
// import { FormTypes } from '@/utils/JEditableTableUtil'
// import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'

import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

import pick from "lodash.pick";

import { gameImgUpload, findGamePicList ,getStudentList ,addClassStudents} from "@/api/api";

export default {
  name: "SelectStudentModal",
  mixins: [JeecgListMixin],
  props: {},
  data() {
    return {
      visible:false,
      firstIsNotLoad:true,
      selectedRowKeys: [],
      form: this.$form.createForm(this),
      loading:false,
      queryParam:{
        realname:"",
      },
      columns: [
        {
          title: '学员',
          align: 'center',
          dataIndex: 'realname',
          width: 200
        },
        {
          title: '性别',
          align: 'center',
          dataIndex: 'sex_dictText',
          width: 120
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'phone',
          width: 100
        },
        {
          title: '课程名',
          align: 'center',
          dataIndex: 'courseNames',
          width: 100
        }
      ],
      dataSource: [
        
      ],
      url: {
        list: "/userInfo/student/list"
      },
      classId:""
    };
  },
  methods: {
    onSearch(){

    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    handleTableChange(){

    },
    handleOk() {
      // this.form.validateFields((err, values) => {

        let that = this;
        
        if(this.selectedRowKeys.length==0){
          this.$message.warning('至少选择一位学员');
          return;
        }
          
        addClassStudents({userId:this.selectedRowKeys.join(','),gradeId:this.classId}).then((res)=>{
          if(res.code==200){
            that.visible = false;
            that.$message.success('添加成功');
            that.$emit('ok');

          }else{
            that.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
          // alert();

          // this.$parent.saveGameSettingData(values);

      // });
      // this.visible = false;
      // if(this.selectCurType==1){
      //   this.$router.push({ path:'/myGame/gameEditor?courseId='+this.courseId+"&chapterId="+this.chapterId});
      // }
    },
    handleCancel() {
      this.visible = false;
    },

    add(id) {
      let _this = this;
      _this.visible = true;
      this.classId = id;
    }
  },
  mounted() {
    // this.getImgListData();
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { "X-Access-Token": token, "X-Access-Admin": "admin" };
    this.loadData();
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    }
  }
};
</script>

<style lang="scss" scoped >
.game-setting-page {
  min-height: 400px;
  .line-data-list {
    .line-data-item {
      margin-bottom: 10px;
      .line-data-select {
        margin-right: 10px;
      }
      .del-line-data {
        color: red;
        cursor: pointer;
        margin-left: 10px;
        vertical-align: top;
        margin-top: 14px;
      }
    }
  }
}
.img-upload-list-pager {
  text-align: center;
  .ant-pagination {
    display: inline-block;
  }
}
.voice-item {
  float: left;
  margin-right: 20px;
  .voice-item-title {
    text-align: center;
    padding: 5px 0px;
  }
}
</style>